import { render, staticRenderFns } from "./labelBadge.vue?vue&type=template&id=c00c0fd8&"
import script from "./labelBadge.vue?vue&type=script&lang=js&"
export * from "./labelBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports